import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Nullable } from 'clickNgo/models/utils'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { ProductExhibitsEditMode } from './components/productExhibitsEditMode/ProductExhibitsEditMode'
import { ProductExhibitsReadMode } from './components/productExhibitsReadMode/ProductExhibitsReadMode'
import { TRANSLATION_KEYS } from './translations'

interface IProductExhibitsProps {
  exhibits: Nullable<string>
}

export const ProductExhibits: FC<IProductExhibitsProps> = ({ exhibits }) => {
  const isEditMode = useSelector(selectPublishingMode)
  return (
    <div>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && <ProductExhibitsReadMode exhibits={exhibits} />}
      {isEditMode && <ProductExhibitsEditMode exhibits={exhibits} />}
    </div>
  )
}
